/* eslint-disable indent , no-nested-ternary */
const i18n = (...params) => window.Messages(...params);

export const template = ({ store }, storeIndex) => {
  // Template params
  const slice = store.open.current_slice;

  let streetAddress = '';
  store.address.lines.forEach(line => {
    if (line) streetAddress += `<span>${line}</span><br>`;
  });
  streetAddress += `<span>${store.address.zipcode} ${store.address.city}</span><br>`;

  const contactPhone = store && store.contact && store.contact.phone;

  return `

  <dt class="store-selection__store-header js-store-result" data-id-store="${store.store_id}">
    <h4>${storeIndex + 1} - ${store.name}</h4>

    ${
      store.open.open_now /* OPEN / CLOSE + current slice */
        ? `<span class="store-selection__hours">
        ${i18n('storeselection.storeOpeningHours', slice.start, slice.end)}
        </span>`
        : `<span class="store-selection__hours store-selection__hours--closed">
          ${i18n('storeselection.storeIsClosed')}
        </span>`
    }

    <span class="icon icon-arrow1-r"></span>
  </dt>
  <dd class="store-selection__store-details js-store-result" data-id-store="${store.store_id}">
    <p>
      ${streetAddress}
      ${contactPhone ? `<a href="tel:${contactPhone}">${contactPhone}</a>` : ''}
    </p>
    <button class="cta-v2 cta-v2--2nd cta-v2--outline cta-v2--s js-store-selection">${i18n('storeselection.selectAStoreCta')}</button>
  </dd>
  `;
};



// WEBPACK FOOTER //
// ./src/commons/component/store-finder/templates/template-plp.js